import { Injectable } from '@angular/core'
import { from, Observable, throwError } from 'rxjs'
import { HttpRequest, HttpClient, HttpResponse, HttpParams } from '@angular/common/http'
import { map, catchError } from 'rxjs/operators'
// import { environment } from '@env/environment';
import { environment } from 'src/environments/environment'

@Injectable({
  providedIn: 'root'
})
export class ApploggerService {
  constructor(private http: HttpClient) {}

  public LogApiError(apiUrl: string, excep: string, screenId: string, statusCode: string): Observable<any> {
    const locale = 'en-US'
    const payLoad = {
      endPointUrl: apiUrl,
      exception: excep,
      screenId,
      statusCode: statusCode.toString()
    }
    const icwLoggerApi = (environment as any)?.icwLoggerApi
    if (!icwLoggerApi) {
      throw new Error(`No icwLoggerApi in env\n${payLoad}`)
    }
    if (icwLoggerApi === 'localhost:3000') {
      return from([])
    }

    const url = `${icwLoggerApi}/global/error/logs`
    return this.http.post(url, payLoad).pipe(
      catchError(err => {
        return throwError(err)
      })
    )
  }

  public LogWarn(apiUrl: string, excep: string, stactTrace: string, screenId: string, statusCode: string): void {
    this.LogException(apiUrl, excep, stactTrace, screenId, statusCode, 'warn').subscribe()
  }

  public LogInfo(apiUrl: string, excep: string, stactTrace: string, screenId: string, statusCode: string): void {
    this.LogException(apiUrl, excep, stactTrace, screenId, statusCode, 'info').subscribe()
  }

  public LogError(apiUrl: string, excep: string, stactTrace: string, screenId: string, statusCode: string): void {
    this.LogException(apiUrl, excep, stactTrace, screenId, statusCode, 'error').subscribe()
  }


  private LogException(
    apiUrl: string,
    excep: string,
    stactTrace: string,
    screenId: string,
    statusCode: string,
    expType: string
  ): Observable<any> {

    const payLoad = {
      url: apiUrl,
      message: excep,
      stackTrace: stactTrace,
      context: { key1: screenId, key2: statusCode != null ? statusCode.toString() : null }
    }
    const icwapi_providerApi = (environment as any).icwapi_providerApi
    if (!icwapi_providerApi) {
      throw new Error(`No icwapi_providerApi in env\n${payLoad}`)
    }
    if (icwapi_providerApi === 'localhost:3000') {
      return from([])
    }
    const url = `${icwapi_providerApi}/log/` + expType
    return this.http.post(url, payLoad).pipe(
      catchError(err => {
        return throwError(err)
      })
    )
  }
}
